import { message } from 'antd';
import { cache } from '@/utils';

const FlowProPid = 28;

const CONFIG = {
  Flow: {
    // Flow FlowPro 共用一个定制贴
    pids: [22, FlowProPid],
    customSkinPid: 433,
    customSkinCid: 2186,
    customType: 'FlowCustom',
  },
  GO3: {
    pids: [24],
    customSkinPid: 462,
    customSkinCid: 2372,
    customType: 'GO3Custom',
  },
  GO3S: {
    pids: [27],
    customSkinPid: 548,
    customSkinCid: 3140,
    customType: 'GO3SCustom',
  },
};

const getConfigList = ({ key = [], product = '' }) => {
  const list = [];
  if (product && CONFIG[product]) {
    key.forEach((item) => {
      list.push(CONFIG[product][item]);
    });
  }
  if (!product) {
    Object.values(CONFIG).forEach((item) => {
      key.forEach((keyItem) => {
        list.push(item[keyItem]);
      });
    });
  }
  return list.flat();
};

const CustomSkinPidList = getConfigList({ key: ['customSkinPid'] });

const CustomSkinCidList = getConfigList({ key: ['customSkinCid'] });

const ValidFlowCustomPidList = getConfigList({
  key: ['pids', 'customSkinPid'],
  product: 'Flow',
});

const ValidGO3CustomPidList = getConfigList({
  key: ['pids', 'customSkinPid'],
  product: 'GO3',
});

const ValidGO3SCustomPidList = getConfigList({
  key: ['pids', 'customSkinPid'],
  product: 'GO3S',
});

const ValidCustomTypeList = getConfigList({ key: ['customType'] });

/**
 *
 * @description 定制贴数据处理
 * @param {String} customType 定制贴类型 GO3Custom || FlowCustom || ...
 * @param {String} action 操作类型
 * @param {Object} val 数据对象
 * @param {Function} cb 回调函数
 * @return
 */
const handleCustomCache = ({ customType, action, val, cb }) => {
  try {
    if (!customType) throw new Error('Custom Cache Handler ProductType is required');
    if (!ValidCustomTypeList.includes(customType)) throw new Error('Custom Cache Handler ProductType is not supported');
    const key = `ins_${customType}`;
    let customCache = cache.get(key) ? JSON.parse(cache.get(key)) : [];
    switch (action) {
      case 'get':
        return customCache;
      case 'set':
        customCache = [val];
        cache.set(key, JSON.stringify(customCache));
        break;
      case 'setAddedToCart':
        customCache.forEach((o) => {
          o.addedToCart = true;
          // 用于购物车计算数量, 产品页到购物车数量累加
          if (o.cartItemCount) {
            o.cartItemCount += o.count;
          } else {
            o.cartItemCount = o.count;
          }
          // 加入购物车后重置产品页数量为1
          o.count = 1;
        });
        cache.set(key, JSON.stringify(customCache));
        break;
      case 'getAddToCart':
        return customCache.filter((o) => o.addedToCart);
      case 'getCartItemCount':
        customCache = customCache.filter((o) => o.addedToCart);
        return customCache.reduce((total, cur) => total + (cur.cartItemCount || 0), 0);
      case 'getCountAllItem':
        return customCache.reduce((total, cur) => total + (cur.count || 0), 0);
      case 'remove':
        customCache = customCache.filter((o) => o.id !== val.id);
        cache.set(key, JSON.stringify(customCache));
        break;
      case 'reset':
        cache.set(key, JSON.stringify([]));
        customCache = [];
        break;
      default:
        break;
    }

    cb && cb();
  } catch (e) {
    console.log(e);
  }
};

const isValidPage = ({ type, productId }) => {
  switch (type) {
    case 'GO3S':
      return ValidGO3SCustomPidList.includes(productId);
    case 'GO3':
      return ValidGO3CustomPidList.includes(productId);
    case 'Flow':
      return ValidFlowCustomPidList.includes(productId);
    default:
      return false;
  }
};

/**
 *
 * @description 是否为定制贴单独购买页，根据套餐id匹配
 */
const isCustomSkin = ({ commodityId }) => {
  return CustomSkinCidList.includes(commodityId);
};

/**
 *
 * @description 是否默认加载定制贴
 */
const defaultLoadCustomSkin = ({ productId }) => {
  return [FlowProPid].includes(productId);
};

/**
 *
 * @description 根据定制贴产品id或定制贴套餐id判断当前定制贴类型
 * @param {Number} commodityId 套餐id
 * @param {Number} productId 产品id
 * @return {String} customType
 */
const getCustomType = ({ commodityId, productId }) => {
  let type = '';
  Object.values(CONFIG).forEach((item) => {
    if (item.customSkinPid === productId || item.customSkinCid === commodityId) {
      type = item.customType;
    }
  });
  return type;
};

const handleProductPageCounterChange = ({ productDetail, mobxOrder, count }) => {
  const customType = getCustomType({ productId: productDetail?.id });
  if (!customType) return;
  const customSkinList = handleCustomCache({ customType, action: 'get' });
  if (customSkinList[0]) {
    customSkinList[0]['count'] = count;
    handleCustomCache({ customType, action: 'set', val: customSkinList[0] });
  }
};

const handleProductPageSubmit = ({ mobxProduct }) => {
  const { extraCustomSkin, productDetail } = mobxProduct;
  const customType = getCustomType({ productId: productDetail?.id });
  const result = {
    isCustomSkinPage: !!customType,
    hasCustomSkin: extraCustomSkin.length,
  };
  return result;
};

const handleSetGO3SAddToCartColor = ({ commodity }) => {
  const isGO3S = commodity.product === 27;
  if (!isGO3S) return;

  const customSkinList = handleCustomCache({ customType: 'GO3SCustom', action: 'get' }) ?? [];
  const customSkinItem = customSkinList[0];
  if (!customSkinItem) return;

  // 当前选择白色GO3S
  const isWhite = commodity.name.indexOf('白色') > -1;
  const sameAsCustomSkin = customSkinItem.isWhite === isWhite;
  if (sameAsCustomSkin) return;

  // 如果当前选择套餐和默认定制颜色不一样，则更换定制贴颜色记录以便购物车及结账页后续展示
  const tempUrl = customSkinItem.customer_image_url;
  customSkinItem.customer_image_url = customSkinItem.customer_extra_image_url;
  customSkinItem.customer_extra_image_url = tempUrl;
  customSkinItem.isWhite = !customSkinItem.isWhite;

  // 给定制贴打标，并在下单时要传新的图到后端做更新
  customSkinItem.needUpdateRemove = true;
  handleCustomCache({
    customType: 'GO3SCustom',
    action: 'set',
    val: customSkinItem,
  });
};

const handleAddedToCart = ({ commodityId, mobxOrder }) => {
  const customType = getCustomType({ commodityId });
  if (!customType) return;
  handleCustomCache({
    customType,
    action: 'setAddedToCart',
  });
};

/**
 *
 * @description 处理购物车定制贴数据，并返回新的列表
 * @date 2024/05/18 18:26:17
 * @param  {Array} cartItems 购物车数据列表
 * @param  {Array} cartGroupList  购物车要展示的列表
 * @param  {Object} mobxOrder  order mobx 状态
 * @return {Array} cartGroupList
 */
const handleCartPageCustomSkin = ({ cartItems = [], cartGroupList = [], mobxOrder }) => {
  cartItems.forEach((item) => {
    const customType = getCustomType({ commodityId: item.commodityId });
    if (!!customType) {
      const c = JSON.parse(JSON.stringify(item));
      c.imageList = handleCustomCache({ customType, action: 'getAddToCart' });
      cartGroupList.push({
        type: customType,
        node_id: null,
        commodities: [c],
      });
      cartItems = cartItems.filter((o) => o.commodityId !== item.commodityId);
    }
  });
  return cartGroupList;
};

const hasCustomSkinFromList = ({ items = [] }) => {
  let hasCustomSkin = false;
  items.forEach((item) => {
    const customType = getCustomType({ commodityId: item.commodityId });
    if (!!customType) {
      hasCustomSkin = true;
    }
  });
  return hasCustomSkin;
};

/**
 *
 * @description loadCardDetail处理购物车和结账页定制贴数据
 * @date 2024/05/18 18:26:17
 * @param  {Object} cartItem 购物车item要单独存储本地缓存数量进行判断
 * @param  {Object} LANG 文案
 * @param  {String} from 来源
 * @return cartItem || null
 */
const handleCartCache = ({ cartItem, mobxOrder, LANG }) => {
  const isCustomSkinItem = isCustomSkin({ commodityId: cartItem?.commodityId });

  if (!isCustomSkinItem) return cartItem;

  const customType = getCustomType({ commodityId: cartItem.commodityId });

  if (!customType) return cartItem;

  // 获取已加入购物车的定制缓存
  const customListCacheFromCart = handleCustomCache({ customType, action: 'getAddToCart' });
  const itemCache = customListCacheFromCart[0];

  if (itemCache) {
    itemCache.count = cartItem.count;
    itemCache.cartItemCount = cartItem.count;
    handleCustomCache({
      customType,
      action: 'set',
      val: itemCache,
    });
    return cartItem;
  }

  if (!itemCache) return null;
};

const handleOrderSummaryItem = ({ orderItem, mobxOrder }) => {
  const state = {
    isCustomSkin: false,
    customImageList: [],
  };
  const customType = getCustomType({ commodityId: orderItem.commodityId });
  state.isCustomSkin = customType;

  if (!state.isCustomSkin) return state;
  state.customImageList = handleCustomCache({ customType, action: 'getAddToCart' });

  return state;
};

/**
 *
 * @description 下单添加定制贴参数
 * @param {Object} orderItem 当前下单商品
 * @param {Object} tempOrderData 临时下单数据
 * @return
 */
const handleOrderCreate = ({ orderItems = [], tempOrderData = {}, mobxOrder }) => {
  const CUSTOM_TYPE = {
    'FlowCustom': 'fmg_customed_shell',
    'GO3Custom': 'go3_customed_shell',
    'GO3SCustom': 'go3s_customed_shell',
  };

  orderItems.forEach((orderItem) => {
    const customType = getCustomType({ commodityId: orderItem.commodityId });

    if (!customType) return tempOrderData;

    const customListCacheFromCart = handleCustomCache({ customType, action: 'getAddToCart' })[0];
    if (customListCacheFromCart) {
      const info = {
        imageId: customListCacheFromCart.id,
        customNumber: orderItem.number,
        commodityId: orderItem.id,
        customType: CUSTOM_TYPE[customType] ?? '',
        type: customType,
      };

      if (customListCacheFromCart.needUpdateRemove) info.customerImageUrl = customListCacheFromCart.customer_image_url;

      tempOrderData.customItemImageInfos.push(info);
    }
  });

  return tempOrderData;
};

export default {
  CustomSkinPidList,
  CustomSkinCidList,
  isValidPage,
  isCustomSkin,
  defaultLoadCustomSkin,
  getCustomType,
  handleCustomCache,
  handleProductPageSubmit,
  handleSetGO3SAddToCartColor,
  handleAddedToCart,
  handleProductPageCounterChange,
  hasCustomSkinFromList,
  handleCartPageCustomSkin,
  handleCartCache,
  handleOrderSummaryItem,
  handleOrderCreate,
};
